<template>
    <header class="app-header">
        <!-- Burger opens the navigation drawer on mobile; hidden on desktop where the sidebar is always visible. -->
        <button class="app-header-burger" :aria-label="$t('menu')" @click="$emit('toggle-nav')">
            <i class="fa-solid fa-bars"></i>
        </button>
        <div class="app-header-title">
            <span class="app-header-eyebrow">{{ $t('appName') }}</span>
            <span class="app-header-client">{{ clientName }}</span>
        </div>
        <div class="app-header-actions">
            <button v-if="$store.state.clients.length > 1" class="app-header-switch" @click="switchClient">
                <i class="fa-solid fa-arrows-rotate"></i> {{ $t('switchClient') }}
            </button>
            <LanguageSwitcher class="lang-switch-header" />
        </div>
    </header>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

export default {
    name: 'AppHeader',
    components: { LanguageSwitcher },
    emits: ['toggle-nav'],
    computed: {
        clientName() {
            const client = this.$store.getters.selectedClient;
            if (!client) return '';
            return client.sport_center_name || client.name;
        }
    },
    methods: {
        switchClient() {
            this.$router.push({ name: 'select-client' });
        }
    }
};
</script>
